import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledWrapperControl = styled.div`
  width: 100%;
  margin-bottom: ${rem('20px')};
  ${mediaqueries.greaterThan('mobile')`
        margin-left: ${rem('20px')};
      `};
  ${mediaqueries.greaterThan('tablet')`
        &:nth-child(2n + 1){
          margin-left: 0;
        }
        width: calc(50% - 10px);    
      `};
  ${mediaqueries.greaterThan('desktop')`
        max-width: ${rem('178px')}; 
        width: auto;
        margin-bottom: 0;
        margin-left: ${rem('20px')};
        &:nth-child(2n + 1){
          margin-left: ${rem('20px')};
        }
        &:first-child{
          margin-left: 0;
        }
    `};
`;

export { StyledWrapperControl };
